export default __webpack_public_path__ + "static/media/gallery31.9b5d75b0.jpg";